import { normalizeLocaleCode } from "./normalizeLocaleCode";

const UI_LOCALES = ["en", "uk", "hi", "id", "th", "vi", "ar"] as const;

export type UiLocale = (typeof UI_LOCALES)[number];

export const resolveMenuLocale = (
  rawUrlLocale: string | null | undefined,
  availableIsoCodes: string[],
  primaryIsoCode: string
): string => {
  const normalizedUrlLocale = normalizeLocaleCode(rawUrlLocale);

  const matchedIsoCode = availableIsoCodes.find(
    (isoCode) => normalizeLocaleCode(isoCode) === normalizedUrlLocale
  );

  return matchedIsoCode ?? primaryIsoCode;
};

export const resolveUiLocale = (menuLocaleIsoCode: string): UiLocale => {
  const normalizedMenuLocale = normalizeLocaleCode(menuLocaleIsoCode);

  if (!UI_LOCALES.includes(normalizedMenuLocale as UiLocale)) {
    return "en";
  }

  return normalizedMenuLocale as UiLocale;
};
